import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  ALERT_CREATE_ALERT_SET_BEGIN,
  ALERT_CREATE_ALERT_SET_SUCCESS,
  ALERT_CREATE_ALERT_SET_FAILURE,
  ALERT_CREATE_ALERT_SET_DISMISS_ERROR,
} from './constants';
import { serviceCreate } from '../../../common/feathers';

export const createAlertSet = serviceCreate('alertSets', {
  begin: ALERT_CREATE_ALERT_SET_BEGIN,
  success: ALERT_CREATE_ALERT_SET_SUCCESS,
  fail: ALERT_CREATE_ALERT_SET_FAILURE,
});

export function dismissCreateAlertSetError() {
  return {
    type: ALERT_CREATE_ALERT_SET_DISMISS_ERROR,
  };
}

export function useCreateAlertSet() {
  const dispatch = useDispatch();

  const { createAlertSetPending, createAlertSetError } = useSelector(
    state => ({
      createAlertSetPending: state.alert.createAlertSetPending,
      createAlertSetError: state.alert.createAlertSetError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(createAlertSet(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissCreateAlertSetError());
  }, [dispatch]);

  return {
    createAlertSet: boundAction,
    createAlertSetPending,
    createAlertSetError,
    dismissCreateAlertSetError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ALERT_CREATE_ALERT_SET_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        createAlertSetPending: true,
        createAlertSetError: null,
      };

    case ALERT_CREATE_ALERT_SET_SUCCESS:
      // The request is success
      return {
        ...state,
        createAlertSetPending: false,
        createAlertSetError: null,
      };

    case ALERT_CREATE_ALERT_SET_FAILURE:
      // The request is failed
      return {
        ...state,
        createAlertSetPending: false,
        createAlertSetError: action.data.error,
      };

    case ALERT_CREATE_ALERT_SET_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        createAlertSetError: null,
      };

    default:
      return state;
  }
}
